import {useCallback, useState, useEffect} from 'react'
import {getToken} from '../lib/api'
import {getApi} from '../lib/fetch'

export const useAssets = (organisationId: string, environmentId: string) => {
  const [placeholders, setPlaceholders] = useState<string[]>([])
  const [assetMap, setAssetMap] = useState<{[placeholder: string]: string}>({})

  useEffect(() => {
    // TODO work out how to only load new images, without depending on assetMap
    // here, which causes a circular dep
    const payload = {
      placeholders
    }
    getApi({organisationId, getToken})(
      'post',
      `/workbench/v1/media/${environmentId}/getReadUrls`,
      payload
    ).then(resp => {
      const data = JSON.parse(resp.body).data
      const readUrls = data?.readUrls
      if (!readUrls) return

      // preload each new url before adding it, so it shows straight away
      Object.entries(readUrls).forEach(([placeholder, url]) => {
        const isVideo = typeof url === 'string' && url.endsWith('.mp4')
        const element = isVideo ? document.createElement('video') : new Image()
        // eslint-disable-next-line functional/immutable-data
        element[isVideo ? 'onloadeddata' : 'onload'] = () => {
          setAssetMap(current => ({
            ...current,
            [placeholder]: url as string
          }))
        }
        // eslint-disable-next-line functional/immutable-data
        element.src = url as string
      })
    })
  }, [environmentId, organisationId, placeholders])

  const getAssetUrl = useCallback(
    (placeholder: string) => {
      setPlaceholders(current => {
        return current.indexOf(placeholder) === -1
          ? current.concat(placeholder)
          : current
      })

      if (!(placeholder in assetMap)) {
        return fallbackImage
      }

      return assetMap[placeholder] as string
    },
    [assetMap]
  )

  return getAssetUrl
}

// transparent pixel
const fallbackImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
